import _ from 'lodash';
import { DEFAULT_BRAND } from '../branding';
import ConfigService from './config.service';

const supportArticles = {
  default: {
    adminGuide: '/wxp-collaboration-admin-portal-memo',
    csvImports: '/wxp-collaboration-admin-buildings-spaces-networks',
    customThresholds: '/wxp-collaboration-admin-portal-memo',
    downSampling: '/monitoring-metric-trends-and-kpis',
    monitorTypes: '/monitors-vs-events-based-monitoring',
    qualityImprovements: '/quality-metrics-explained',
    upgradeCollector: '/collector-setup',
    urlRequirements: '/wxp-collaboration-cloud-url-requirements',
    webhooksSetup: '/setting-up-webhooks-for-alert-notifications',
    userDetails: '/wxp-collaboration',
  },
  gov: {
    adminGuide: '/360047419834',
    csvImports: '/360058496074',
    customThresholds: '/4402451118739-Best-practices-for-setting-advanced-experience-monitoring-custom-thresholds',
    downSampling: '/1500004542441-Downsampling-in-CPM-Monitoring-Metric-Trends-and-KPIs',
    monitorTypes: '/19557916951443',
    qualityImprovements: '/360040849074-Improvements-to-Vyopta-s-Quality-Metrics',
    upgradeCollector: '/9305925435667-Collector-Maintenance-Upgrade',
    urlRequirements: '/4402039908243-URL-Requirements-for-the-Vyopta-Suite-of-Products',
    webhooksSetup: '/4408960202259-How-to-setup-webhooks-for-Monitors-alerts-notifications',
    userDetails: '/../',
  }
};

// The branding service is a facade on top of the configuration properties in
// branding/index.js to facilitate using these properties in the UI to control
// the look of thee product
//
// The default values can be overridden individually by setting the
// BROWSER_CONFIG env var for the ui-container
// e.g. for att we set
//    "BROWSER_CONFIG":"{ allowCreateAccount: false, allowForgotPassword: false, hideCopyright: true, privacyUrl: '', termsUrl: '', loginLogoUrl: 'dist/images/att-logo-blk-type.png', loginLogoAlt: 'att', loginIFrameUrl: '', loginIFrameAltTitleImage: 'dist/images/att_login_product_name.png', loginIFrameAltTitle: '', loginIFrameAltCopy: '', navLogo: 'dist/images/att_logo_medium_white.png', navLogoShield: 'dist/images/att_logo_shield.png', supportUrl: '', }"
// there are two other env vars used by the UI container as well (not used by
// the branding service)
//    "BROWSER_TITLE":"AT&T Enhanced Reporting and Analytics",
//    "BROWSER_FAVICON":"dist/images/favicon-att.ico",

class BrandingService {

  constructor () {
    if(BrandingService.instance) {
      return BrandingService.instance;
    }

    this.brand = _.assign(DEFAULT_BRAND, ConfigService.getInstance().getBranding());

    BrandingService.instance = this;
  }

  getLoginLogoUrl () {
    return this.brand.loginLogoUrl;
  }

  getLoginDarkLogoUrl () {
    return this.brand.loginDarkLogoUrl;
  }

  getLoginLogoAlt () {
    return this.brand.loginLogoAlt;
  }

  getHideCopyright () {
    return this.brand.hideCopyright;
  }

  getPrivacyUrl () {
    return this.brand.privacyUrl;
  }

  getTermsUrl () {
    return this.brand.termsUrl;
  }

  getAllowCreateAccount () {
    return this.brand.allowCreateAccount;
  }

  getAllowForgotPassword () {
    return this.brand.allowForgotPassword;
  }

  getNavLogo () {
    return this.brand.navLogo;
  }

  getNavLogoDark () {
    return this.brand.navLogoDark;
  }

  getSupportUrl (article) {
    const baseUrl = this.brand.supportUrl || 'https://learn.workforceexperience.hp.com';

    if (article) {
      if (this.isGov()) {
        return baseUrl + '/articles' + supportArticles.gov[article];
      }
      return baseUrl + '/docs' + supportArticles.default[article];
    }

    return baseUrl;
  }

  // todo: unused
  getSupportContactUrl () {
    return this.brand.supportContactUrl || 'https://learn.workforceexperience.hp.com/docs/wxp-collaboration';
  }

  isGov () {
    return window.Config.isGov;
  }
}


const instance = new BrandingService();
Object.freeze(instance);

export default instance;
